import request from '@/utils/request'

export default {
  getCurrencyRate () {
    return request({
      url: `${process.env.VUE_APP_API}/v3/exchangeRates`,
      method: 'get'
    })
  },
  getPageStructure (params) {
    return request({
      url: `${process.env.VUE_APP_API}/v3/home`,
      method: 'get',
      params
    })
  },
  getBannerList () {
    return request({
      url: `${process.env.VUE_APP_API}/v3/CTABanner`,
      method: 'get'
    })
  }
}
